import ReactGA from "react-ga4";
import { Button, Layout } from "../../components";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";

export const NotFound = () => {
  ReactGA.send({ hitType: "pageview", page: "/*" });
  const navigate = useNavigate();

  const handleClick = (redirect) => () => {
    navigate(redirect);
  };

  return (
    <>
      <Layout>
        <div className="not-found">
          <div className="not-found__content">
            <h1 className="not-found__title">¡Oh no!</h1>
            <span className="not-found__subtitle">
              No podemos encontrar la página que estás buscando o quizás, no
              existe.
            </span>
            <span className="not-found__error">Código de error: 404</span>
            <div className="not-found__button-container">
              <Button
                color="#FCFCFC"
                bgColor="#262255"
                onHandleClick={handleClick("/")}
              >
                Regresa a la página principal
              </Button>
            </div>
          </div>
          <div className="not-found__image">
            <div className="not-found__image-container">
              <img
                src="./notFound/ufo-1.svg"
                className="not-found__ufo-icon"
                alt=""
              />
              <img
                src="./notFound/ufo-2.svg"
                className="not-found__ray-one"
                alt=""
              />
              <img
                src="./notFound/ufo-3.svg"
                className="not-found__ray-two"
                alt=""
              />
            </div>
            <img
              src="./notFound/road.svg"
              className="not-found__road-image"
              alt=""
            />
          </div>
        </div>
      </Layout>
    </>
  );
};
